(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRotator(root) {
      if (root.dataset.rotatorReady) return;
      var slides = root.querySelectorAll('.announcement-bar__slide');
      if (slides.length < 2) return;
      root.dataset.rotatorReady = '1';

      // devolve o controle ao CSS: o inline existe só para o intervalo
      // entre o HTML e a folha de estilo da seção
      for (var s = 0; s < slides.length; s++) slides[s].style.opacity = '';

      var idx = 0;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var delay = reduce ? 7000 : 4500;

      setInterval(function () {
        slides[idx].classList.remove('is-active');
        idx = (idx + 1) % slides.length;
        slides[idx].classList.add('is-active');
      }, delay);
    }

    var bars = document.querySelectorAll('[data-announcement-rotator]');
    for (var i = 0; i < bars.length; i++) {
      initRotator(bars[i]);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
